import * as tslib_1 from "tslib";
import Separator from 'sinoui-components/Separator';
var FormSeparator = Separator.extend(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-bottom: 16px;\n  color: ", ";\n"], ["\n  margin-bottom: 16px;\n  color: ", ";\n"])), function (props) { return props.theme.palette.text.primary; });
export default FormSeparator;
var templateObject_1;
//# sourceMappingURL=FormSeparator.js.map